"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function Tooltip(_a) {
    var children = _a.children, text = _a.text, placement = _a.placement, _b = _a.childrenStyles, childrenStyles = _b === void 0 ? {} : _b;
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var isMobile = (0, useMediaQuery_1.default)("(max-width:600px)");
    if (!text) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    if (isMobile) {
        return ((0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, __assign({ onClickAway: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ arrow: true, title: text, onClose: function () { return setOpen(false); }, open: open, PopperProps: {
                    className: "twap-tooltip",
                    style: {
                        maxWidth: 360,
                    },
                }, placement: placement }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ onClick: function () { return setOpen(true); }, style: __assign(__assign({}, childrenStyles), { minWidth: 0 }) }, { children: children })) })) })));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ arrow: true, title: text, PopperProps: {
            className: "twap-tooltip",
            style: {
                maxWidth: 350,
            },
        }, placement: placement }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: __assign({}, childrenStyles), className: "twap-tooltip-children" }, { children: children })) })));
}
exports.default = Tooltip;
